<div class="page service-page">
  <app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>
  <h4 class="title">{{ 'pages.service.infoRequest.title' | translate }}</h4>
  <div class="content-wrapper">
    <app-service-steps
      [steps]="steps"
      [activeItem]="currentStep"
      [lastAvailableStep]="lastAvailableStep"
      [isLoading]="isAllLoading"
      [isSubmitted]="false"
      [hasFormChanged]="hasFormChanged"
      serviceName="infoRequest"
      (stepSelected)="handleStepSelected()"
      (changesDiscarded)="handleChangesDiscarded()" />
    <div class="form-wrapper">
      @if (!isAllLoading && client) {
        @if (currentStep === requestStep) {
          <app-info-request-form
            [client]="client!"
            [application]="application"
            [topics]="topics"
            [isSubmittingFiles]="isSubmittingFiles"
            [savedDocumentFiles]="documentFiles"
            (applicationUpdated)="handleApplicationUpdated($event)"
            (formChanged)="handleFormChanged($event)"
            (fileUploading)="handleFileUploading($event)"
            (documentsChanged)="handleDocumentsChanged($event)"
            (draftSaved)="handleDraftFilesUpload()" />
        } @else if (currentStep === clientAndPayerStep && application) {
          <app-info-request-client-payer-form
            [client]="client!"
            [application]="application"
            [selectedTopic]="getSelectedTopic()"
            [isSubmittingFiles]="isSubmittingFiles"
            [savedClientPayerFiles]="clientPayerFiles"
            [fpContactData]="fpContactData"
            (applicationUpdated)="handleApplicationUpdated($event)"
            (formChanged)="handleFormChanged($event)"
            (clientPayerFilesChanged)="handleClientPayerFilesChanged($event)"
            (fileUploading)="handleFileUploading($event)"
            (draftSaved)="handleClientPayerDraftFilesUpload()"
            (legalEntityUpdated)="legalEntity = $event"
            (jpCompanyDataChanged)="jpCompanyData = $event"
            (fpContactDataChanged)="fpContactData = $event" />
        } @else if (currentStep === summaryStep && application) {
          <app-info-request-summary
            [client]="client!"
            [application]="application"
            [topics]="topics"
            [documentFiles]="documentFiles"
            [clientPayerFiles]="clientPayerFiles"
            [uploadedFiles]="uploadedFiles"
            [legalEntityInput]="legalEntity"
            [jpCompanyData]="jpCompanyData"
            (applicationUpdated)="handleApplicationUpdated($event)"
            (documentFilesChanged)="handleDocumentsChanged($event)"
            (clientPayerFilesChanged)="handleClientPayerFilesChanged($event)" />
        }
      } @else if (isAllLoading) {
        <div class="spinner-wrapper">
          <app-spinner [isLoading]="true" />
        </div>
      } @else {
        <div class="spinner-wrapper">
          <p>{{ 'pages.service.infoRequest.clientNotFound' | translate }}</p>
        </div>
      }
    </div>
  </div>
</div>

<app-confirm-modal
  [isOpen]="isOpenLeaveConfirm"
  (confirm)="onLeaveConfirm()"
  (cancel)="onLeaveCancel()"
  title="unsavedChanges"
  bodyText="unsavedChangesBody"
  confirmText="continue"
  denyText="cancelBack" />
